import ContainerForm from 'components/ContainerForm';
import { InputTitle } from 'components/input/InputTitle';
import CommonSelect from 'components/select/CustomSelect';
import { StatusTag } from 'components/tag/StatusTag';
import { TagComponent } from 'components/tag/TagComponent';
import { Row, Spacing, Typography } from 'enable-ui';

import { RoleKey } from 'modules/auth/core/enum';
import { BorderContainer } from 'modules/dashboard/styles/common';

import { checkRole } from 'helpers';

import { COLOR } from 'constants/color';

import { ClassesForm } from '../components/ClassesForm';
import { ThumbnailComp } from '../components/ThumbnailComp';
import { useClassesDetailController } from '../core/controller/classes-detail';
import { getStyleClassCompletion } from '../core/helpers';

export const ClassesDetailPage = () => {
  const {
    code,
    isActive,
    classCompletion,
    name,
    description,
    handleChange,
    handleSubmit,
    disabled,
    onCancel,
    thumbnail,
    onChangeThumbnail,
    onDeleteThumbnail,
    institution,
    handleGetWidthAndHeightThumbnail,
    onChangeStation,
    selectedStation,
    mappingStations,
    station,
  } = useClassesDetailController();

  const isBiologicAdmin = checkRole([RoleKey.BIOLOGIC_ADMIN]);

  const { color, borderColor, backgroundColor } = getStyleClassCompletion(classCompletion);

  return (
    <ContainerForm
      onCancel={onCancel}
      onSubmit={() => handleSubmit()}
      disabled={disabled}
      disabledCancel={disabled}
      titleSubmit="Save"
      titleCancel="Cancel changes"
    >
      <BorderContainer className={thumbnail ? 'pb-0' : ''}>
        <Typography variant="h4" weight={500} color={COLOR.surfaceNeutralBold['neutral-11']}>
          Class details
        </Typography>

        <Row className="mt-24 max-w-800">
          <Row direction="column">
            <InputTitle title="Class ID" unsetMarginBottom />
            <Typography
              className="mt-2"
              variant="body-2"
              color={COLOR.surfaceNeutralBold['neutral-11']}
            >
              {code ?? ''}
            </Typography>
          </Row>

          {isBiologicAdmin && (
            <Row direction="column">
              <InputTitle title="Institution" unsetMarginBottom />
              <Typography
                className="mt-2"
                variant="body-2"
                color={COLOR.surfaceNeutralBold['neutral-11']}
              >
                {institution ?? ''}
              </Typography>
            </Row>
          )}
        </Row>

        <Row className="mt-24 max-w-800">
          <Row direction="column">
            <InputTitle title="Status" />
            <StatusTag isActive={Boolean(isActive)} />
          </Row>

          <Row direction="column">
            <InputTitle title="Class completion" />
            <TagComponent color={color} text={classCompletion} />
          </Row>
        </Row>

        <ClassesForm
          name={name ?? ''}
          description={description ?? ''}
          handleChange={handleChange}
        />

        <ThumbnailComp
          extraClass="mt-24 max-w-800"
          file={thumbnail ?? ''}
          onChangeFiles={onChangeThumbnail}
          onDeleteThumbnail={onDeleteThumbnail}
          handleGetWidthAndHeightThumbnail={handleGetWidthAndHeightThumbnail}
        />
      </BorderContainer>

      <BorderContainer className="mt-24">
        <Typography variant="h4" weight={500} color={COLOR.surfaceNeutralBold['neutral-11']}>
          Center and address
        </Typography>

        <Spacing className="mt-24 max-w-800">
          <InputTitle title="Center" />
          <CommonSelect
            isBorderInput
            value={selectedStation as { value: string; label: string }}
            options={mappingStations}
            onChange={onChangeStation}
            onInputChange={() => {}}
          />
        </Spacing>

        {station && (
          <Spacing className="mt-24">
            <InputTitle title="Address" />
            <Typography variant="body-2" color={COLOR.surfaceNeutralBold['neutral-11']}>
              {station?.address ? station?.address + ',' : ''}{' '}
              {station?.city ? station?.city + ',' : ''}{' '}
              {station?.state ? station?.state + ',' : ''}{' '}
              {station?.country ? station?.country : ''}
            </Typography>
          </Spacing>
        )}
      </BorderContainer>
    </ContainerForm>
  );
};
